import { MutationCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

// רשת ביטחון גלובלית: מוטציה שנכשלת בלי onError משלה הייתה נבלעת בשקט,
// והמשתמש היה רואה "לחצתי שמור ושום דבר לא קרה". כאן כל כישלון כזה מוצג.
// מוטציות עם onError משלהן עדיין מטפלות בעצמן — ה-cache לא דורס אותן,
// לכן מדלגים כאן כדי לא להציג הודעה כפולה.
const mutationCache = new MutationCache({
	onError: (error, _vars, _ctx, mutation) => {
		if (mutation?.options?.onError) return;
		console.error('[Mutation failed]', error);
		toast.error(error?.message || 'הפעולה נכשלה. נסו שוב.');
	},
});

export const queryClientInstance = new QueryClient({
	mutationCache,
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: 1,
		},
	},
});
